import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import DeleteDialog from './DeleteDialog';

import { deleteEditorForm } from '../../../store/formEditor/actions';

function Editor (props) {
    const { form, handleClose } = props;
    if (!form) return null;

    const handleDelete = () => {
        const { history, basePath } = props;
        props.deleteEditorForm().then(() => {
            handleClose();
            history.replace(basePath);
        });
    };

    return (
        <DeleteDialog
            handleClose={handleClose}
            handleDelete={handleDelete}
            form={form}
        />
    );
}

const mapStateToProps = state => ({
    form: state.formEditor.form,
    basePath: state.path.basePath
});

const mapDispatchToProps = dispatch => ({
    deleteEditorForm: () => dispatch(deleteEditorForm())
});

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(Editor);
